export const AW_INTEGRATIONS_API_URL = process.env?.AWAPI_AWINTEGRATIONS_URL || '/api/wealth/integrations';
